import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { mql } from "./breakpoints";

export const Wrapper = styled.section`
  padding: ${ (props: { padding?: string | number | false }) => props.padding ?? "0 16px" };
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
  width: 100%;
  overflow: hidden;

  ${ mql.md } {
    padding: 0 40px;

  }
`;

export const centered = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const vertical = css`
  display: flex;
  align-items: center;
`;

export const semanticList = css`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ellipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const p = (val: number) => css`
  padding: ${ val }px;
`;

export const pt = (val: number) => css`
  padding-top: ${ val }px;
`;

export const pr = (val: number) => css`
  padding-right: ${ val }px;
`;

export const pb = (val: number) => css`
  padding-bottom: ${ val }px;
`;

export const pl = (val: number) => css`
  padding-left: ${ val }px;
`;

export const px = (val: number) => css`
  padding-left: ${ val }px;
  padding-right: ${ val }px;
`;

export const py = (val: number) => css`
  padding-top: ${ val }px;
  padding-bottom: ${ val }px;
`;

export const m = (val: number) => css`
  margin: ${ val }px;
`;

export const mt = (val: number) => css`
  margin-top: ${ val }px;
`;

export const mr = (val: number) => css`
  margin-right: ${ val }px;
`;

export const mb = (val: number) => css`
  margin-bottom: ${ val }px;
`;

export const ml = (val: number) => css`
  margin-left: ${ val }px;
`;

export const mx = (val: number) => css`
  margin-left: ${ val }px;
  margin-right: ${ val }px;
`;

export const my = (val: number) => css`
  margin-top: ${ val }px;
  margin-bottom: ${ val }px;
`;

export const p0 = css`padding: 0`;
export const m0 = css`margin: 0`;

export const fontObj = "font-family: ObjectSans, SFProDisplay, sans-serif;";
export const articleFont = css`
  font-size: 16px;
  line-height: 24px;

  &:not(:last-child) {
    margin-bottom: 8px;

  }

  ${ mql.md } {
    font-size: 18px;
    line-height: 27px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
`;